export default [{
  value: -1,
  label: 'All'
}, {
  value: 0,
  label: 'New'
}, {
  value: 9,
  label: 'FTP download completed'
}, {
  value: 10,
  label: 'File read'
}, {
  value: 20,
  label: 'All records read'
}, {
  value: 80,
  label: 'Ready for OCR'
}, {
  value: 89,
  label: 'OCR completed'
}, {
  value: 90,
  label: 'Processing records'
}, {
  value: 91,
  label: 'Processing record'
}, {
  value: 95,
  label: 'Ready for destination'
}, {
  value: 96,
  label: 'Waiting for FTP upload'
}, {
  value: 100,
  label: 'Processed'
}, {
  value: 200,
  label: 'Error occured'
}, {
  value: 210,
  label: 'Error in record'
}, {
  value: 300,
  label: 'Removed'
}, {
  value: 390,
  label: 'FTP upload failed'
}, {
  value: 391,
  label: 'FTP download failed'
}, {
  value: 400,
  label: 'Failed'
}, {
  value: 500,
  label: 'On Hold'
}, {
  value: 600,
  label: 'DateTrigger'
}]

export const SELECTABLE_STATUS_VALUES = [-1, 0, 95, 100, 200, 210, 300, 400, 500]
